import React from "react";
import Contact from "./components/contact/Contact";

const ContactTwo = () => {
  return <Contact />;
};

export default ContactTwo;
